/* Kazakh translations — keyed by the Russian source string (same pattern as bookify-pro) */
const data = {

    /* General */
    "Отмена": "Болдырмау",
    "Отменить": "Болдырмау",
    "Сохранить": "Сақтау",
    "Сохраняю…": "Сақтаудамын…",
    "Удалить": "Жою",
    "Готово": "Дайын",
    "Продолжить": "Жалғастыру",
    "Отправляем…": "Жіберудеміз…",
    "Назад": "Артқа",
    "Закрыть": "Жабу",
    "Копировать": "Көшіру",
    "Код скопирован": "Код көшірілді",
    "Загрузка…": "Жүктелуде…",
    "Показать ещё": "Тағы көрсету",
    "Сбросить фильтры": "Сүзгілерді тазалау",
    "По запросу": "Сұраныс бойынша",
    "от": "бастап",

    /* Header / navigation */
    "Войти": "Кіру",
    "Найти": "Іздеу",
    "Поиск услуг, организаций и мастеров": "Қызметтерді, ұйымдарды және шеберлерді іздеу",
    "Город": "Қала",
    "Все услуги": "Барлық қызметтер",
    "Все категории": "Барлық санаттар",
    "Главная": "Басты бет",
    "Популярно:": "Танымал:",
    "Недавние": "Соңғы",
    "Популярные запросы": "Танымал сұраулар",
    "Популярное": "Танымал",
    "Организации": "Ұйымдар",
    "Услуги": "Қызметтер",
    "Ищем…": "Іздеудеміз…",

    /* Account / profile */
    "Профиль": "Профиль",
    "Мои записи": "Менің жазбаларым",
    "Мои отзывы": "Менің пікірлерім",
    "Избранное": "Таңдаулылар",
    "Сертификаты": "Сертификаттар",
    "Уведомления": "Хабарламалар",
    "Помощь": "Көмек",
    "Помощь и поддержка": "Көмек және қолдау",
    "Общее": "Жалпы",
    "Дополнительно": "Қосымша",
    "Выйти из аккаунта": "Аккаунттан шығу",
    "Редактировать профиль": "Профильді өңдеу",
    "Язык": "Тіл",
    "Загрузить фото": "Фото жүктеу",
    "Удалить аккаунт": "Аккаунтты жою",

    /* Booking / queue */
    "Записаться": "Жазылу",
    "Позвонить": "Хабарласу",
    "Открыто до": "Ашық",
    "Закрыто": "Жабық",
    "Выходной": "Демалыс",
    "Встать в очередь": "Кезекке тұру",
    "Покинуть очередь": "Кезектен шығу",
    "Живая очередь": "Электронды кезек",
    "человек впереди": "адам алдыда",
    "Выберите специалиста": "Маманды таңдаңыз",
    "Выберите дату": "Күнді таңдаңыз",
    "Выберите время": "Уақытты таңдаңыз",
    "Выберите время, чтобы записаться": "Жазылу үшін уақытты таңдаңыз",
    "Выбрать время": "Уақытты таңдау",
    "Итого": "Барлығы",
    "Нет доступных слотов на выбранную дату": "Таңдалған күнге бос уақыт жоқ",
    "Свободного времени нет": "Бос уақыт жоқ",
    "На ближайшую неделю мастер занят. Выберите другого специалиста — у него может быть свободнее": "Алдағы аптада маман бос емес. Басқа маманды таңдаңыз — оның уақыты болуы мүмкін",
    "На ближайшую неделю мастер занят. Загляните позже или позвоните в заведение": "Алдағы аптада маман бос емес. Кейінірек қараңыз немесе орынға қоңырау шалыңыз",

    /* Reviews */
    "Оставить отзыв": "Пікір қалдыру",
    "Как прошёл визит?": "Бару қалай өтті?",
    "Оцените мастера и оставьте отзыв": "Шеберді бағалап, пікір қалдырыңыз",
    "Активные": "Белсенді",
    "История": "Тарих",

    /* Search / filters */
    "Рядом": "Жақын жерде",
    "Цена": "Бағасы",
    "Рейтинг": "Рейтинг",
    "Время работы": "Жұмыс уақыты",
    "Сортировка:": "Сұрыптау:",
    "По рейтингу": "Рейтинг бойынша",
    "Открыто сейчас": "Қазір ашық",

    /* Account — profile / logout */
    "Эти данные будут видны организациям при записи": "Бұл деректер жазылу кезінде ұйымдарға көрінеді",
    "Ваше имя": "Атыңыз",
    "Укажите имя": "Атыңызды енгізіңіз",
    "Email (необязательно)": "Email (міндетті емес)",
    "Смена номера — через подтверждение по коду": "Нөмірді ауыстыру — код арқылы растау",
    "Дата рождения": "Туған күні",
    "Без имени": "Атсыз",
    "Профиль сохранён": "Профиль сақталды",
    "Фото обновлено": "Фото жаңартылды",
    "Не удалось загрузить фото": "Фотоны жүктеу мүмкін болмады",
    "Фото удалено": "Фото жойылды",
    "Удаляем…": "Жоюдамыз…",
    "Удалить фото?": "Фотоны жою керек пе?",
    "Удалить аккаунт?": "Аккаунтты жою керек пе?",
    "Фото профиля будет удалено.": "Профиль фотосы жойылады.",
    "Вы потеряете доступ к записям, отзывам и сертификатам. Восстановить аккаунт можно только через поддержку.": "Сіз жазбаларға, пікірлерге және сертификаттарға қолжетімділікті жоғалтасыз. Аккаунтты тек қолдау қызметі арқылы қалпына келтіруге болады.",
    "Выйти": "Шығу",
    "Выйти из аккаунта?": "Аккаунттан шығу керек пе?",
    "Вы выйдете из профиля на этом устройстве. Чтобы войти снова, понадобится номер телефона.": "Сіз осы құрылғыда профильден шығасыз. Қайта кіру үшін телефон нөмірі қажет.",

    /* Favourites */
    "Организации, которые вы сохранили": "Сіз сақтаған ұйымдар",
    "Здесь пока ничего нет": "Мұнда әзірге ештеңе жоқ",
    "Добавьте организации в избранное, чтобы не потерять.": "Жоғалтпау үшін ұйымдарды таңдаулыларға қосыңыз.",
    "На главную": "Басты бетке",

    /* Notifications */
    "Записи, напоминания и предложения": "Жазбалар, еске салулар және ұсыныстар",
    "Уведомлений пока нет": "Әзірге хабарламалар жоқ",
    "Здесь появятся записи, напоминания и предложения.": "Мұнда жазбалар, еске салулар және ұсыныстар пайда болады.",

    /* Bookings */
    "Управляйте предстоящими и прошедшими записями": "Алдағы және өткен жазбаларды басқарыңыз",
    "Создана": "Жасалды",
    "Завершена": "Аяқталды",
    "Отменена": "Бас тартылды",
    "Связаться": "Байланысу",
    "На карте": "Картада",
    "Отменить запись": "Жазбаны болдырмау",
    "Отменить запись?": "Жазбаны болдырмау керек пе?",
    "Отменяется…": "Болдырылуда…",

    /* Reviews */
    "Поделитесь впечатлениями — это помогает другим": "Әсеріңізбен бөлісіңіз — бұл басқаларға көмектеседі",
    "Оставленные": "Қалдырылған",
    "Ожидают отзыв": "Пікір күтуде",
    "Вы пока не оставили отзывов": "Сіз әзірге пікір қалдырмадыңыз",
    "Поделитесь впечатлениями после визита.": "Барғаннан кейін әсеріңізбен бөлісіңіз.",
    "Нет записей для отзыва": "Пікір қалдыруға жазба жоқ",
    "Завершённые записи появятся здесь.": "Аяқталған жазбалар мұнда пайда болады.",
    "Редактировать": "Өңдеу",
    "Удалить отзыв?": "Пікірді жою керек пе?",
    "Отзыв будет удалён без возможности восстановления.": "Пікір қалпына келтірусіз жойылады.",
    "Удаляется…": "Жойылуда…",
    "Ответ организации": "Ұйымның жауабы",
    "Отзыв обновлён": "Пікір жаңартылды",
    "Отзыв опубликован": "Пікір жарияланды",
    "Не удалось сохранить отзыв": "Пікірді сақтау мүмкін болмады",
    "Фото из отзыва": "Пікірдегі фото",

    /* Gifts / certificates */
    "Подарить сертификат": "Сертификат сыйлау",
    "Подарить ещё": "Тағы сыйлау",
    "Подарочные сертификаты, полученные и отправленные вами": "Сіз алған және жіберген сыйлық сертификаттары",
    "Мои сертификаты": "Менің сертификаттарым",
    "Я подарил": "Мен сыйладым",
    "Сертификат": "Сертификат",
    "Активен": "Белсенді",
    "Использован": "Қолданылды",
    "Истёк": "Мерзімі өтті",
    "Ожидает оплаты": "Төлем күтуде",
    "Оплата не прошла": "Төлем өтпеді",
    "Номинал": "Номинал",
    "Действует до": "Дейін жарамды",
    "Кому": "Кімге",
    "Остаток": "Қалдық",
    "Показать QR-код": "QR-кодты көрсету",
    "Код сертификата": "Сертификат коды",
    "Покажите QR-код мастеру для активации сертификата": "Сертификатты іске қосу үшін QR-кодты шеберге көрсетіңіз",
    "Сертификатов пока нет": "Әзірге сертификаттар жоқ",
    "Вы ещё не дарили сертификаты": "Сіз әлі сертификат сыйламадыңыз",
    "Здесь появятся подарочные сертификаты, которые вам отправили.": "Мұнда сізге жіберілген сыйлық сертификаттары пайда болады.",
    "Подарите близким заботу о себе — сертификат принимается во всех салонах Bookify.": "Жақындарыңызға өзіне қамқорлық сыйлаңыз — сертификат барлық Bookify салондарында қабылданады.",

    /* Help */
    "Помощь и обратная связь": "Көмек және кері байланыс",
    "Частые вопросы": "Жиі қойылатын сұрақтар",
    "Сообщение отправлено!": "Хабарлама жіберілді!",
    "Написать ещё": "Тағы жазу",
    "Тема": "Тақырып",
    "Сообщение": "Хабарлама",
    "Отправить": "Жіберу",

    /* Weekday abbreviations */
    "Вс": "Жс",
    "Пн": "Дс",
    "Вт": "Сс",
    "Ср": "Ср",
    "Чт": "Бс",
    "Пт": "Жм",
    "Сб": "Сб",
    "выхд": "дем",

    /* Month abbreviations */
    "янв": "қаң",
    "фев": "ақп",
    "мар": "нау",
    "апр": "сәу",
    "май": "мам",
    "июн": "мау",
    "июл": "шіл",
    "авг": "там",
    "сен": "қыр",
    "окт": "қаз",
    "ноя": "қар",
    "дек": "жел",

    /* Booking modal */
    "Не удалось загрузить": "Жүктеу мүмкін болмады",
    "Повторить": "Қайталау",
    "Запись создана!": "Жазба жасалды!",
    "Ждём вас в": "Сізді күтеміз —",
    "Напомним за час до записи.": "Жазбаға бір сағат қалғанда еске саламыз.",
    "Отлично": "Тамаша",
    "Записываем...": "Жазудамыз...",
    "Новая запись": "Жаңа жазба",

    /* Certificate modal */
    "Универсальный": "Әмбебап",
    "Для неё": "Әйелге",
    "Для него": "Еркекке",
    "SPA & уход": "SPA & күтім",
    "Закат": "Күн батысы",
    "Ночь": "Түн",
    "Не удалось оформить сертификат. Попробуйте позже.": "Сертификатты рәсімдеу мүмкін болмады. Кейінірек қайталаңыз.",
    "Подарочный сертификат": "Сыйлық сертификаты",
    "Имя получателя": "Алушының аты",
    "Код": "Код",
    "Выберите номинал": "Номиналды таңдаңыз",
    "Своя сумма (до 100 000 ₸)": "Өз сомаңыз (100 000 ₸ дейін)",
    "Например, 30 000": "Мысалы, 30 000",
    "Минимальный номинал — 1 000 ₸": "Ең төменгі номинал — 1 000 ₸",
    "Кому дарим": "Кімге сыйлаймыз",
    "Например, Айгерим": "Мысалы, Айгерім",
    "Укажите имя получателя": "Алушының атын енгізіңіз",
    "Телефон получателя": "Алушының телефоны",
    "Введите корректный номер": "Дұрыс нөмір енгізіңіз",
    "От кого": "Кімнен",
    "Поздравление": "Құттықтау",
    "С праздником! Дарю тебе заботу о себе ✨": "Мерекеңмен! Саған өзіңе қамқорлық сыйлаймын ✨",
    "С Днём рождения! 🎁": "Туған күніңмен! 🎁",
    "С праздником, ты заслуживаешь лучшего ✨": "Мерекеңмен, сен ең жақсысына лайықсың ✨",
    "Просто порадовать 💛": "Жай ғана қуанту 💛",
    "Оплата": "Төлем",
    "Комиссия": "Комиссия",
    "Оформляем...": "Рәсімдеудеміз...",
    "Оплатить": "Төлеу",
    "Отправили в": "Жіберілді —",
    "для": "—",
    "на номер": ", нөмір:",
    "Доставим в": "Жеткіземіз —",
    "в день праздника.": "мереке күні.",
    "Сертификат оформлен!": "Сертификат рәсімделді!",
    "Получатель": "Алушы",
    "Действует 12 месяцев · принимается во всех салонах Bookify": "12 ай жарамды · барлық Bookify салондарында қабылданады",

    /* Notifications drawer */
    "только что": "жаңа ғана",
    "мин назад": "мин бұрын",
    "ч назад": "сағ бұрын",
    "вчера": "кеше",
    "день назад": "күн бұрын",
    "дня назад": "күн бұрын",
    "дней назад": "күн бұрын",
    "Сегодня": "Бүгін",
    "Ранее": "Бұрын",
    "Войдите, чтобы видеть уведомления": "Хабарламаларды көру үшін кіріңіз",
    "Здесь будут записи, напоминания и предложения": "Мұнда жазбалар, еске салулар және ұсыныстар болады",
    "Здесь появятся записи, напоминания и предложения": "Мұнда жазбалар, еске салулар және ұсыныстар пайда болады",
    "Настройки уведомлений": "Хабарлама баптаулары",
    "Push, SMS и email — выберите, что получать": "Push, SMS және email — нені алатыныңызды таңдаңыз",
    "По выбранным фильтрам ничего не найдено.": "Таңдалған сүзгілер бойынша ештеңе табылмады.",

    /* Search page */
    "Алматы": "Алматы",
    "в": "—",
    "Найдено": "Табылды",
    "организаций": "ұйым",
    "Списком": "Тізіммен",

    /* Authorization */
    "Не удалось отправить код": "Кодты жіберу мүмкін болмады",
    "Неверный код": "Қате код",
    "Не удалось сохранить": "Сақтау мүмкін болмады",
    "Вход": "Кіру",
    "Чтобы продолжить, введите номер телефона —": "Жалғастыру үшін телефон нөмірін енгізіңіз —",
    "мы отправим код подтверждения в WhatsApp или SMS.": "біз растау кодын WhatsApp немесе SMS арқылы жібереміз.",
    "Телефон": "Телефон",
    "Нажимая кнопку «Продолжить», вы соглашаетесь с": "«Жалғастыру» түймесін басу арқылы сіз мыналармен келісесіз:",
    "Политикой конфиденциальности": "Құпиялылық саясаты",
    "и": "және",
    "Публичной офертой": "Жария оферта",
    "Подтвердите телефон": "Телефонды растаңыз",
    "Мы отправили код подтверждения": "Біз растау кодын жібердік",
    "Введите 4-значный код": "4 таңбалы кодты енгізіңіз",
    "Проверяем код…": "Кодты тексерудеміз…",
    "Повторная доставка кода будет доступна через": "Кодты қайта жіберу мына уақыттан кейін қолжетімді:",
    "сек": "сек",
    "Отправить код повторно": "Кодты қайта жіберу",
    "Изменить номер": "Нөмірді өзгерту",
    "Как вас зовут?": "Атыңыз кім?",
    "Завершите регистрацию — имя видят организации при записи.": "Тіркелуді аяқтаңыз — жазылу кезінде ұйымдар атыңызды көреді.",
    "Сохраняем…": "Сақтаудамыз…",

    /* Service picker */
    "Выберите услугу": "Қызметті таңдаңыз",
    "Маникюр, стрижка, автомойка...": "Маникюр, шаш қию, автожуу...",
    "Ничего не нашлось по запросу": "Сұраныс бойынша ештеңе табылмады",

    /* When modal */
    "Когда": "Қашан",
    "Быстрый выбор": "Жылдам таңдау",
    "Завтра": "Ертең",
    "На этой неделе": "Осы аптада",
    "В следующей неделе": "Келесі аптада",
    "Конкретный день": "Нақты күн",

    /* Footer / menu */
    "Бронируйте услуги в лучших организациях Казахстана за пару кликов.": "Қазақстанның үздік ұйымдарында қызметтерді бірнеше клик арқылы брондаңыз.",
    "Микрорайон Мамыр 1, 26, БЦ Quorum, 508 кабинет, Алматы": "Мамыр 1 ықшамауданы, 26, Quorum БО, 508 кабинет, Алматы",
    "Для клиентов": "Клиенттерге",
    "Поиск организаций": "Ұйымдарды іздеу",
    "Подарочные сертификаты": "Сыйлық сертификаттары",
    "Скачать приложение": "Қосымшаны жүктеу",
    "Для бизнеса": "Бизнеске",
    "Подключить организацию": "Ұйымды қосу",
    "Тарифы": "Тарифтер",
    "CRM для мастеров": "Шеберлерге арналған CRM",
    "Партнёрская программа": "Серіктестік бағдарламасы",
    "О компании": "Компания туралы",
    "Поддержка": "Қолдау",
    "Контакты": "Байланыс",
    "Публичная оферта": "Жария оферта",
    "Политика конфиденциальности": "Құпиялылық саясаты",
    "Поиск услуг, организаций...": "Қызметтерді, ұйымдарды іздеу...",
    "Войти в Bookify": "Bookify-ге кіру",

    /* Intro splash */
    "Запись за пару кликов": "Бірнеше клик арқылы жазылу",

    /* Leave review */
    "Ужасно": "Өте нашар",
    "Плохо": "Нашар",
    "Так себе": "Орташа",
    "Хорошо": "Жақсы",
    "Изменить отзыв": "Пікірді өзгерту",
    "Вы оцениваете": "Сіз бағалап отырсыз:",
    "У кого вы были?": "Сіз кімде болдыңыз?",
    "Специалист": "Маман",
    "Ваша оценка": "Сіздің бағаңыз",
    "Расскажите о визите": "Бару туралы айтыңыз",
    "Что понравилось, что можно улучшить?": "Не ұнады, нені жақсартуға болады?",
    "Добавить фото": "Фото қосу",
    "Покажите результат — до 5 фото": "Нәтижені көрсетіңіз — 5 фотоға дейін",
    "Выбрать": "Таңдау",
    "Сохранение…": "Сақталуда…",
    "Публикация…": "Жариялануда…",
    "Сохранить изменения": "Өзгерістерді сақтау",
    "Опубликовать отзыв": "Пікірді жариялау",
    "Публикуя отзыв, вы соглашаетесь с": "Пікір жариялау арқылы сіз мынамен келісесіз:",
    "политикой конфиденциальности": "құпиялылық саясаты",
    "Далее": "Әрі қарай",

    /* City modal */
    "Выберите город": "Қаланы таңдаңыз",

    /* Card */
    "В избранное": "Таңдаулыларға",

    /* Network error */
    "Что-то пошло не так": "Бірдеңе дұрыс болмады",
    "Проверьте соединение и попробуйте снова.": "Байланысты тексеріп, қайта көріңіз.",

    /* Home — hero */
    "200+ салонов, мастерских и автосервисов": "200+ салон, шеберхана және автосервис",
    "Запись и": "Жазылу және",
    "живая очередь": "электронды кезек",
    "— за пару кликов": "— бірнеше клик арқылы",
    "Маникюр, стрижка, ресницы, массаж, автомойка, шиномонтаж и СТО — бронируйте онлайн или вставайте в живую очередь по геолокации.": "Маникюр, шаш қию, кірпік, массаж, автожуу, шина ауыстыру және СТО — онлайн брондаңыз немесе геолокация бойынша электронды кезекке тұрыңыз.",
    "Услуга": "Қызмет",
    "Очередь · 3 чел": "Кезек · 3 адам",
    "шиномонтаж рядом": "жақын жердегі шина ауыстыру",
    "Запись · 18:30": "Жазылу · 18:30",
    "сегодня, маникюр": "бүгін, маникюр",
    "12 320 отзывов": "12 320 пікір",
    "салонов и сервисов": "салон мен сервис",
    "записей в месяц": "айына жазба",
    "средний рейтинг": "орташа рейтинг",
    "2 мин": "2 мин",
    "занимает запись": "жазылуға кетеді",

    /* Home — promo */
    "Популярное заведение": "Танымал мекеме",
    "Уникальный подход, качественный уход и тёплая атмосфера.": "Ерекше көзқарас, сапалы күтім және жылы орта.",
    "Найдите своё место": "Өз орныңызды табыңыз",
    "Подарок близким": "Жақындарға сыйлық",
    "Электронные сертификаты от 5 000 ₸ — на любую услугу": "5 000 ₸-ден бастап электронды сертификаттар — кез келген қызметке",
    "Купить": "Сатып алу",
    "CRM и онлайн-запись для салонов": "Салондарға арналған CRM және онлайн-жазылу",
    "Стать партнёром": "Серіктес болу",

    /* Home — sections */
    "Категории услуг": "Қызмет санаттары",
    "Выберите, что нужно сделать": "Не істеу керектігін таңдаңыз",
    "Повторить запись": "Жазбаны қайталау",
    "Услуги, на которые вы записывались раньше": "Бұрын жазылған қызметтеріңіз",
    "Все мои записи": "Барлық жазбаларым",
    "Последний визит": "Соңғы бару",
    "Рядом с вами": "Сізге жақын",
    "Ближайшие заведения по вашему местоположению": "Орналасқан жеріңізге ең жақын мекемелер",
    "Смотреть все": "Барлығын көру",
    "Как работает Bookify": "Bookify қалай жұмыс істейді",
    "Запись занимает меньше 2 минут": "Жазылу 2 минуттан аз уақыт алады",

    /* Home — how it works */
    "Найдите услугу": "Қызметті табыңыз",
    "Выберите услугу, район и удобное время.": "Қызметті, ауданды және ыңғайлы уақытты таңдаңыз.",
    "Выберите мастера": "Шеберді таңдаңыз",
    "Сравните цены, рейтинги и отзывы.": "Бағаларды, рейтингтерді және пікірлерді салыстырыңыз.",
    "Запишитесь онлайн": "Онлайн жазылыңыз",
    "Получите подтверждение и напоминание.": "Растау мен еске салуды алыңыз.",

    /* Home — app cta */
    "Bookify в кармане": "Bookify қалтаңызда",
    "Скачайте приложение": "Қосымшаны жүктеп алыңыз",
    "Записывайтесь в пару касаний, получайте напоминания о визитах и эксклюзивные предложения салонов — прямо в телефоне.": "Бірнеше рет түртіп жазылыңыз, бару туралы еске салуларды және салондардың эксклюзивті ұсыныстарын тікелей телефоныңыздан алыңыз.",
    "Скачать в App Store": "App Store-дан жүктеу",
    "Загрузите в": "Жүктеп алыңыз:",
    "Скачать в Google Play": "Google Play-ден жүктеу",
    "Доступно в": "Қолжетімді:",
    "Приложение Bookify": "Bookify қосымшасы",

    /* Service categories */
    "Маникюр": "Маникюр",
    "Стрижка": "Шаш қию",
    "Окрашивание": "Бояу",
    "Автомойка": "Автожуу",
    "Шиномонтаж": "Шина ауыстыру",
    "Массаж": "Массаж",
    "Наращивание ногтей": "Тырнақ өсіру",
    "Педикюр": "Педикюр",
    "Снятие покрытия": "Жабынды алу",
    "Подология": "Подология",
    "Стрижка волос": "Шаш қию",
    "Укладка волос": "Шаш сәндеу",
    "Брейдинг": "Брейдинг",
    "Наращивание ресниц": "Кірпік өсіру",
    "Брови": "Қастар",
    "Ламинирование": "Ламинация",
    "Косметология": "Косметология",
    "SPA": "SPA",
    "СТО · ремонт": "СТО · жөндеу",
    "Детейлинг": "Детейлинг",
    "Полировка": "Жылтырату",

    /* Organization page */
    "Ссылка скопирована": "Сілтеме көшірілді",
    "Ваш отзыв опубликован": "Пікіріңіз жарияланды",
    "Часы не указаны": "Жұмыс уақыты көрсетілмеген",
    "Открыто · до": "Ашық ·",
    "Закрыто · сегодня": "Жабық · бүгін",
    "Сегодня выходной": "Бүгін демалыс",
    "Каталог": "Каталог",
    "м от вас": "м сізден",
    "Адрес": "Мекенжай",
    "Показать номер": "Нөмірді көрсету",
    "Часы работы": "Жұмыс уақыты",
    "Свернуть": "Жию",
    "Все дни": "Барлық күндер",
    "Все фото": "Барлық фото",
    "Поделиться": "Бөлісу",
    "человек в живой очереди": "адам электронды кезекте",
    "примерное ожидание": "болжамды күту",
    "мин": "мин",
    "— проверенная организация. Удобная онлайн-запись и высокий рейтинг по отзывам клиентов.": "— тексерілген ұйым. Ыңғайлы онлайн-жазылу және клиент пікірлері бойынша жоғары рейтинг.",
    "Основано на": "Негізі:",
    "Отзывов пока нет.": "Әзірге пікір жоқ.",
    "Все отзывы": "Барлық пікірлер",
    "перед вами · вы в очереди": "сіздің алдыңызда · сіз кезектесіз",
    "мин ожидания": "мин күту",
    "Ваша запись": "Сіздің жазбаңыз",
    "Выберите услуги, чтобы продолжить": "Жалғастыру үшін қызметтерді таңдаңыз",
    "Выходим…": "Шығудамыз…",
    "Встаём…": "Тұрудамыз…",
    "Вы в очереди · уведомим, когда подойдёт": "Сіз кезектесіз · кезегіңіз жеткенде хабарлаймыз",
    "Бесплатно · уведомим, когда подойдёт очередь": "Тегін · кезегіңіз жеткенде хабарлаймыз",
    "Бесплатно · подтверждение за 5 минут": "Тегін · 5 минут ішінде растау",
    "фото": "фото",
    "Карта": "Карта",
    "Маршрут": "Бағыт",
    "Отзывы": "Пікірлер",
    "Все": "Барлығы",
    "Отзывов с такой оценкой пока нет.": "Мұндай бағамен пікір әзірге жоқ.",
    "Информация": "Ақпарат",
    "Специалисты": "Мамандар",
    "Безналичная оплата, рассрочка Kaspi": "Қолма-қол ақшасыз төлем, Kaspi бөліп төлеу",
    "Wi-Fi и горячие напитки": "Wi-Fi және ыстық сусындар",

    /* Search — geolocation note and filter options */
    "Нет доступа к геолокации. Разрешите доступ в браузере, чтобы видеть организации рядом — пока показываем по рейтингу.": "Геолокацияға қолжетімділік жоқ. Жақын жердегі ұйымдарды көру үшін браузерде рұқсат беріңіз — әзірге рейтинг бойынша көрсетіп отырмыз.",
    "Любая цена": "Кез келген баға",
    "₸ · недорого": "₸ · арзан",
    "₸₸ · средне": "₸₸ · орташа",
    "₸₸₸ · премиум": "₸₸₸ · премиум",
    "Любой рейтинг": "Кез келген рейтинг",
    "от 4.5 ★": "4.5 ★ бастап",
    "от 4.7 ★": "4.7 ★ бастап",
    "от 4.9 ★": "4.9 ★ бастап",
    "Любое время": "Кез келген уақыт",
    "По расстоянию": "Қашықтық бойынша",
    "По отзывам": "Пікірлер бойынша",
    "По цене": "Баға бойынша",

    /* About page */
    /* Hero title — kept as one key with a "|" line break so word order stays correct per language (Kazakh puts the verb last) */
    "Записывайтесь|за пару кликов": "Бірнеше клик арқылы|жазылыңыз",
    "Bookify — это платформа онлайн-записи в салоны красоты, барбершопы, SPA и автосервисы Казахстана. Мы помогаем людям находить лучших мастеров рядом, а бизнесу — расти и принимать клиентов без хаоса в расписании.": "Bookify — Қазақстандағы сұлулық салондарына, барбершоптарға, SPA және автосервистерге онлайн-жазылу платформасы. Біз адамдарға жақын жердегі үздік шеберлерді табуға, ал бизнеске — өсуге және кестеде бей-берекетсіздіксіз клиент қабылдауға көмектесеміз.",
    "Найти услугу": "Қызмет табу",
    "Подключить салон": "Салонды қосу",
    "рейтинг в App Store": "App Store-дағы рейтинг",
    "Наша миссия": "Біздің миссиямыз",
    "Мы верим, что забота о себе не должна быть сложной. Раньше запись к мастеру означала звонки, ожидание ответа и неудобные часы. Bookify убирает эти барьеры: вся индустрия красоты и ухода — в одном приложении.": "Біз өзіңе қамқорлық жасау қиын болмауы керек деп сенеміз. Бұрын шеберге жазылу қоңырау шалуды, жауап күтуді және ыңғайсыз уақытты білдіретін. Bookify бұл кедергілерді жояды: сұлулық пен күтімнің бүкіл индустриясы — бір қосымшада.",
    "Клиент за минуту находит салон рядом, видит реальные цены, отзывы и свободное время. А салон получает поток клиентов и инструменты, чтобы управлять записями, не теряя ни одной заявки.": "Клиент бір минутта жақын жердегі салонды табады, нақты бағаларды, пікірлерді және бос уақытты көреді. Ал салон клиенттер ағынын және бірде-бір өтінішті жоғалтпай жазбаларды басқаруға арналған құралдарды алады.",
    "Прозрачные цены и честные отзывы": "Ашық бағалар және шынайы пікірлер",
    "Запись 24/7 без звонков": "24/7 қоңыраусыз жазылу",
    "Поддержка клиентов и салонов": "Клиенттер мен салондарға қолдау",
    "Почему выбирают Bookify": "Неге Bookify-ді таңдайды",
    "Сервис, который одинаково удобен для клиентов и для бизнеса": "Клиенттерге де, бизнеске де бірдей ыңғайлы сервис",
    "Реквизиты компании": "Компания деректемелері",
    "Bookify развивается командой ТОО «SARY GROUP» в Алматы. По вопросам сотрудничества и подключения салонов — пишите и звоните, мы всегда на связи.": "Bookify-ды Алматыдағы «SARY GROUP» ЖШС командасы дамытады. Ынтымақтастық және салондарды қосу мәселелері бойынша — жазыңыз және қоңырау шалыңыз, біз әрдайым байланыстамыз.",
    "Юридическое лицо": "Заңды тұлға",
    "БИН": "БСН",
    "Отдел продаж": "Сату бөлімі",
    "Поддержка салонов": "Салондарға қолдау",
    "Общие вопросы": "Жалпы сұрақтар",
    "БЦ Quorum, Мамыр 1, 26, 508 кабинет": "Quorum БО, Мамыр 1, 26, 508 кабинет",
    "Готовы начать?": "Бастауға дайынсыз ба?",
    "Найдите услугу рядом или подключите свой салон к Bookify уже сегодня.": "Жақын жердегі қызметті табыңыз немесе салоныңызды Bookify-ге бүгін-ақ қосыңыз.",
    "Связаться с нами": "Бізбен байланысу",
    "салонов и мастеров": "салон мен шебер",
    "город Казахстана": "Қазақстан қаласы",
    "средняя оценка сервиса": "сервистің орташа бағасы",
    "Запись за минуту": "Бір минутта жазылу",
    "Выбрали услугу, мастера и время — подтверждение приходит сразу. Без звонков и переписок.": "Қызметті, шеберді және уақытты таңдадыңыз — растау бірден келеді. Қоңыраусыз және хат алмасусыз.",
    "Только проверенные": "Тек тексерілгендер",
    "Реальные отзывы после визита, честные рейтинги и фотографии работ от клиентов.": "Барғаннан кейінгі шынайы пікірлер, әділ рейтингтер және клиенттердің жұмыс фотолары.",
    "Забота о клиенте": "Клиентке қамқорлық",
    "Напоминания о записи, лёгкий перенос и отмена, поддержка на связи каждый день.": "Жазба туралы еске салулар, оңай ауыстыру мен болдырмау, күн сайын байланыстағы қолдау.",
    "Удобно для бизнеса": "Бизнеске ыңғайлы",
    "Онлайн-расписание, база клиентов и аналитика — всё, чтобы салон рос быстрее.": "Онлайн-кесте, клиенттер базасы және аналитика — салон тезірек өсуі үшін бәрі.",

    /* Contacts page */
    "Юр. лицо": "Заңды тұлға",
    "Электронная почта": "Электрондық пошта",
    "Пн–Пт · 10:00–18:00": "Дс–Жм · 10:00–18:00",
    "Свяжитесь с командой Bookify любым удобным способом — мы на связи каждый день и отвечаем в течение нескольких часов.": "Bookify командасымен кез келген ыңғайлы тәсілмен байланысыңыз — біз күн сайын байланыстамыз және бірнеше сағат ішінде жауап береміз.",
    "Bookify на карте — БЦ Quorum, Алматы": "Bookify картада — Quorum БО, Алматы",
    "БЦ Quorum, Bookify": "Quorum БО, Bookify",
    "Микрорайон Мамыр 1, 26, 508 кабинет, Алматы": "Мамыр 1 шағын ауданы, 26, 508 кабинет, Алматы",
    "Открыть в 2ГИС": "2ГИС-те ашу",

    /* Page 404 */
    "Страница не найдена": "Бет табылмады",
    "Возможно, ссылка устарела или страница была удалена.": "Мүмкін сілтеме ескірген немесе бет жойылған.",

    /* Header / Account — icons and empty states */
    "Гость": "Қонақ",
    "Поиск": "Іздеу",
    "Меню": "Мәзір",
    "Ничего не найдено по запросу": "Сұраныс бойынша ештеңе табылмады",

    /* Counted-noun base forms (Kazakh keeps the singular) */
    "отзыв": "пікір",
    "отзыве": "пікір",
    "час": "сағат"
}

export default data
